import { render, staticRenderFns } from "./completeHeader.vue?vue&type=template&id=323b020e&scoped=true&"
import script from "./completeHeader.vue?vue&type=script&lang=js&"
export * from "./completeHeader.vue?vue&type=script&lang=js&"
import style0 from "./completeHeader.vue?vue&type=style&index=0&id=323b020e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b020e",
  null
  
)

export default component.exports